<template>
  <Form ref="companyInfo" class="add-company" :class="{'edit-company': editMode}" :label-width="160" :model="companyInfo" :rules="rules">
    <FormItem v-if="editMode" label="企业编码" prop="name">
      <span class="edit-company-val">1111111</span>
    </FormItem>
    <FormItem label="企业名称" prop="name">
      <span v-if="editMode" class="edit-company-val">1111111</span>
      <Input v-else v-model="companyInfo.name" placeholder="请输入企业名称" style="width: 220px" />
    </FormItem>
    <FormItem label="企业类型">
      <span class="edit-company-val">1111111</span>
    </FormItem>
    <FormItem label="企业域" prop="domain">
      <span v-if="editMode" class="edit-company-val">1111111</span>
      <div v-else class="add-company-item-inner">
        <Input v-model="companyInfo.domain" placeholder="请输入企业域" style="width: 220px" />
        <div class="tip-bottom">小于等于50位字符，可由英文大小写组成</div>
      </div>
    </FormItem>
    <FormItem label="管理员账号" prop="admin">
      <span v-if="editMode" class="edit-company-val">1111111</span>
      <div v-else class="add-company-item-inner">
        <Input v-model="companyInfo.admin" placeholder="请输入管理员账号" style="width: 220px" />
        <span class="tip-bottom">3-15位字符，可由中文和英文组成，建议使用admin</span>
      </div>
    </FormItem>
    <FormItem  :class="{'height-list':editPassword}" label="密码" prop="password">
      <span v-if="editMode && !editPassword" class="edit-company-val">******<a @click="editPassword=true" class="reset-password" href="javascript:;">重置密码</a></span>
      <div v-else class="add-company-item-inner">
        <Input type="password" t v-model="companyInfo.password" placeholder="请输入密码" style="width: 220px" />
        <span class="tip-bottom">6-20位字符，可由英文、数字及标点符号组成</span>
      </div>
    </FormItem>
    <FormItem  :class="{'height-list':editPassword}" v-if="editMode && editPassword" label="确认密码" prop="rePassword">
      <Input type="password" v-model="companyInfo.rePassword" placeholder="请确认密码" style="width: 220px" />
    </FormItem>
    <FormItem label="类型" prop="type">
      <RadioGroup v-model="companyInfo.type">
        <Radio :label="1">试用</Radio>
        <Radio :label="2">正式</Radio>
      </RadioGroup>
    </FormItem>
    <FormItem class="data-item" label="有效期">
      <div class="data-col">
        <FormItem prop="start">
          <DatePicker v-model="companyInfo.start" type="date" placeholder="开始日期" style="width: 220px"></DatePicker>
        </FormItem>
      </div>
      <span class="line"></span>
      <div class="data-col">
        <FormItem prop="end">
          <DatePicker v-model="companyInfo.end" type="date" placeholder="结束日期" style="width: 220px"></DatePicker>
        </FormItem>
      </div>
    </FormItem>
    <FormItem label="开启/禁用" prop="disable">
      <i-switch v-model="companyInfo.disable" size="small" :disabled="disabled"/>
    </FormItem>
    <FormItem label="开启/锁定" prop="lock">
      <i-switch  v-model="companyInfo.lock" size="small" :disabled="disabled"/>
      <span class="tip">
      用户连续登陆3次失败账号将被锁定1小时。手动开启时，请将开关置成“开”的状态
      </span>
    </FormItem>
    <button v-if="!(editMode && !editPassword)" type="primary" @clcik="handleSubmit('companyInfo')" class="ivu-btn ivu-btn-primary">确认提交</button>
  </Form>
</template>

<script>
export default {
  name: 'detailInfo',
  data() {
    const validatePassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else if (value.length < 6) {
        callback(new Error('密码最短为6位'))
      } else if (value.length > 20) {
        callback(new Error('密码最长为20位'))
      } else {
        callback()
      }
    }
    const validateRePassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入确认密码'))
      } else if (value !== this.companyInfo.password) {
        callback(new Error('两次密码输入不一致'))
      } else {
        callback()
      }
    }
    const validateAdmin = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入管理员账号'))
      } else if (value.length < 3) {
        callback(new Error('管理员账号最短为3位'))
      } else if (value.length > 15) {
        callback(new Error('管理员账号最长为15位'))
      } else {
        callback()
      }
    }
    return {
      disabled: false,
      editMode: false,
      editPassword: false,
      companyInfo: {
        name: '',
        domain: '',
        admin: '',
        password: '',
        rePassword: '',
        type: 1,
        start: '',
        end: '',
        disable: false,
        lock: true
      },
      rules: {
        name: [
          { required: true, message: '请输入企业名称', trigger: 'blur' }
        ],
        domain: [
          { required: true, message: '请输入企业域', trigger: 'blur' }
        ],
        admin: [
          { validator: validateAdmin, trigger: 'blur' }
        ],
        password: [
          { validator: validatePassword, trigger: 'blur' }
        ],
        rePassword: [
          { validator: validateRePassword, trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请确认密码', trigger: 'blur' }
        ],
        start: [
          { required: true, type: 'date', message: '请输入开始日期', trigger: 'change' }
        ],
        end: [
          { required: true, type: 'date', message: '请输入结束日期', trigger: 'change' }
        ],
        disable: [
          { required: true, message: '请输入企业名称', trigger: 'blur' }
        ],
        lock: [
          { required: true, message: '请输入企业名称', trigger: 'blur' }
        ]
      },
      value: ''
    }
  },
  created() {
    const pageObj = { title: '', type: 'small', url: '' }
    if (this.$route.name.indexOf('Add') !== -1) {
      this.editMode = false
      pageObj.title = '新增'
    } else {
      this.editMode = true
      pageObj.title = '编辑'
    }
    this.$route.name.indexOf('Industry') !== -1 ? pageObj.url = 'industryList' : pageObj.url = 'serverList'
    this.$store.dispatch('setPage', pageObj)
  },
  methods: {
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$Message.success('Success!')
        } else {
          this.$Message.error('Fail!')
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
